import { React, useState } from 'react';
import { Button } from 'react-bootstrap';
import { library } from '@fortawesome/fontawesome-svg-core';
import { fal } from '@fortawesome/pro-light-svg-icons';
import { FontAwesomeIcon } from '@fortawesome/react-fontawesome';
import { removeFromRejectList } from '../../services';
import { toast } from 'react-toastify';

library.add(fal);

const RejectRemoveButton = ({ profileId, docId }) => {
  const [watch, setWatch] = useState(false);

  const handleClick = async () => {
    try {
      const res = await removeFromRejectList(docId, profileId);
      if (res !== null && res !== undefined) {
        setWatch(true);
        if (typeof window !== 'undefined') {
          window.dispatchEvent(new Event('refreshDocLists'));
        }
        toast.success('Removed from rejected list', {
          position: 'top-right',
          autoClose: 3000,
        });
      }
    } catch (err) {
      toast.error('Failed to remove from rejected list', {
        position: 'top-right',
        autoClose: 3000,
      });
    }
  };

  return (
    <Button
      variant='text'
      onClick={handleClick}
      className='remove-btn remove-rejectlist'
      title='Remove from Reject List'
    >
      <FontAwesomeIcon
        icon={watch ? ['fal', 'check'] : ['fal', 'file-times']}
      ></FontAwesomeIcon>
    </Button>
  );
};
export default RejectRemoveButton;
